import { useEffect, useState } from 'react';
import { ParameterConfigMmodel } from '../../../models/parameter.model';
import parameters from '../../../util/parameters';
import parameterSingleton from '../../../services/Parameters.service';

const useStep3Parameters = () => {
	const [licenceCategoryList, setLicenceCategoryList] = useState<ParameterConfigMmodel[]>([]);
	const [licenceCategoryMotorList, setLicenceCategoryMotorList] = useState<ParameterConfigMmodel[]>(
		[]
	);
	const [listTipoOtrosConocimientos, setListTipoOtrosConocimientos] = useState<
		ParameterConfigMmodel[]
	>([]);
	const [listSalario, setListSalario] = useState<ParameterConfigMmodel[]>([]);
	const [listSalarioMensual, setListSalarioMensual] = useState<ParameterConfigMmodel[]>([]);
	const [listSiNo, setListSiNo] = useState<ParameterConfigMmodel[]>([]);
	const [listSituacionLaboral, setListSituacionLaboral] = useState<ParameterConfigMmodel[]>([]);
	const [listNivelEducativo, setListNivelEducativo] = useState<ParameterConfigMmodel[]>([])
	const [listCategoriaLicenciaPublica, setListCategoriaLicenciaPublica] = useState<ParameterConfigMmodel[]>([]);
	const [listProductosFinancieros, setListProductosFinancieros] = useState<ParameterConfigMmodel[]>([]);
	const [listActividadPrincipal, setListActividadPrincipal] = useState<ParameterConfigMmodel[]>([]);
	const [loadingParams, setloadingParams] = useState(true);

	useEffect(() => {
		getAllParameters();
	}, []);

	const getAllParameters = async () => {
		setloadingParams(true);
		await fetchLicenseCarCategory();
		await fetchLicenseMotorcicleCategory();
		await fetchListTipoOtrosConocimientos();
		await fetchListSalario();
		await fetchListSalarioMensual();
		await fetchListSiNo();
		await fetchListSituacionLaboral();
		await fetchListNivelEducativo();
		await fetchListCategoriaLicenciaPublica();
		await fetchListProductosFinancieros();
		setloadingParams(false);
	};

	const fetchListCategoriaLicenciaPublica = async () => {
		const res = await parameterSingleton.fetchData(parameters.CATEGORIALICENCIAPUBLICA);
		setListCategoriaLicenciaPublica(res);
	};

	const fetchListProductosFinancieros = async () => {
		const res = await parameterSingleton.fetchData(parameters.PRODUCTOSFINANCIEROS);
		setListProductosFinancieros(res);
	};

	/**
	 * HU39: la lista de "Actividad principal actual" depende de la "Situación laboral actual".
	 * El backend filtra las opciones segun la situacion (query param situacion_laboral); se fuerza la
	 * recarga porque el servicio de parametros cachea por tipo y no por parametros.
	 */
	const fetchListActividadPrincipal = async (situacionLaboral?: string) => {
		if (!situacionLaboral) {
			setListActividadPrincipal([]);
			return;
		}
		const res = await parameterSingleton.fetchData(parameters.ACTIVIDADPRINCIPAL, true, {
			situacion_laboral: situacionLaboral,
		});
		setListActividadPrincipal(res);
	};

	const fetchLicenseCarCategory = async () => {
		const res = await parameterSingleton.fetchData(parameters.LINCENCIACARRO);
		setLicenceCategoryList(res);
	};

	const fetchLicenseMotorcicleCategory = async () => {
		const res = await parameterSingleton.fetchData(parameters.LINCENCIAMOTO);
		setLicenceCategoryMotorList(res);
	};

	const fetchListTipoOtrosConocimientos = async () => {
		const res = await parameterSingleton.fetchData(parameters.TIPOCONOCIMIENTOS);
		setListTipoOtrosConocimientos(res);
	};

	const fetchListSalario = async () => {
		const res = await parameterSingleton.fetchData(parameters.SALARIO);
		setListSalario(res);
	};

	const fetchListSalarioMensual = async () => {
		const res = await parameterSingleton.fetchData(parameters.SALARIOMENSUAL);
		const resOrderByCode = res.sort((a, b) => (Number(a.code) > Number(b.code)) ? 1 : -1);
		setListSalarioMensual(resOrderByCode);
	};

	const fetchListSiNo = async () => {
		const res = await parameterSingleton.fetchData(parameters.SINO);
		setListSiNo(res);
	};

	const fetchListSituacionLaboral = async () => {
		const res = await parameterSingleton.fetchData(parameters.SITUACIONLABORAL);
		setListSituacionLaboral(res);
	};

	const fetchListNivelEducativo = async () => {
		const res = await parameterSingleton.fetchData(parameters.NIVELEDUCATIVO);
		setListNivelEducativo(res);
	}

	return {
		licenceCategoryList,
		licenceCategoryMotorList,
		listTipoOtrosConocimientos,
		listSalario,
		listSalarioMensual,
		listSiNo,
		listSituacionLaboral,
		listNivelEducativo,
		listCategoriaLicenciaPublica,
		listProductosFinancieros,
		listActividadPrincipal,
		fetchListActividadPrincipal,
		loadingParams,
	};
};

export default useStep3Parameters;
